import React from 'react';

export default function UsageMeter({ usage, t }) {
  const D = t.dashboard;
  const isPro = usage.plan === 'pro';
  const pct = isPro ? 100 : Math.min(100, (usage.conversions_today / usage.conversions_limit) * 100);
  const color = pct > 80 ? '#e94560' : pct > 50 ? '#f0a500' : '#00d4aa';

  return (
    <div style={{
      background: 'var(--surface)',
      border: '1px solid var(--border)',
      borderRadius: '16px',
      padding: '24px',
      marginBottom: '24px',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px', flexWrap: 'wrap', gap: '8px' }}>
        <div>
          <span style={{ color: '#9ca3af', fontSize: '13px' }}>{D.usage}</span>
          <span style={{ color: '#f0f0f5', fontWeight: 700, fontSize: '20px', margin: '0 8px' }}>
            {isPro ? '∞' : usage.conversions_today}
          </span>
          {!isPro && (
            <span style={{ color: '#6b7280', fontSize: '13px' }}>
              {D.of} {usage.conversions_limit}
            </span>
          )}
        </div>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <span style={{
            background: isPro ? 'rgba(240,165,0,0.12)' : 'rgba(0,212,170,0.12)',
            color: isPro ? '#f0a500' : '#00d4aa',
            border: `1px solid ${isPro ? 'rgba(240,165,0,0.3)' : 'rgba(0,212,170,0.3)'}`,
            borderRadius: '20px', padding: '4px 14px',
            fontSize: '12px', fontWeight: 700,
          }}>
            {usage.plan.toUpperCase()}
          </span>
          <span style={{ color: '#6b7280', fontSize: '12px', alignSelf: 'center' }}>
            {D.usage}: {usage.file_size_limit_mb}MB max
          </span>
        </div>
      </div>

      {!isPro && (
        <div style={{ background: 'rgba(255,255,255,0.06)', borderRadius: '8px', height: '8px', overflow: 'hidden' }}>
          <div style={{
            height: '100%', width: `${pct}%`,
            background: `linear-gradient(90deg, ${color}, ${color}99)`,
            borderRadius: '8px',
            transition: 'width 0.5s ease',
          }} />
        </div>
      )}

      {isPro && (
        <div style={{ color: '#6b7280', fontSize: '13px' }}>{D.unlimited} ∞</div>
      )}
    </div>
  );
}
